<div class="selector-container grid small grid-two">
    <app-selector
      *ngFor="let entry of dataEntries; let isFirst = first; let isLast = last"
      class="what-to-do"
      [id]="entry.ID"
      [name]="entry.name | translate"
      [description]="entry.description | translate"
      [imageClassFromFrontEnd]="entry.imageClassFromFrontEnd"
      [checked]="entry.checked"
      [tooltip]="entry.tooltip"
      [lateralPanelId]="entry.lateralPanelId"
      [isFirst]="isFirst"
      [isLast]="isLast"
      [isSingleItem]="true"
      [showDescription]="true"
      (selected)="onSelectorClicked($event)"
    >
    </app-selector>
</div>

<!--
<app-lateral-panel id="new-lateral" class="subtitle-info-lateral primary"  [extraClasses]="'grey house-footer-image m-w-768'">
  <h3 class="primary m-b-question m-t-question">
    {{'b2c.IDS_WTD_NEW_POPUP_TITLE' | translate}}
  </h3>
  <p class="primary m-b-36">
    {{'b2c.IDS_WTD_NEW_POPUP_DESCRIPTION' | translate}}
  </p>
  <div class="d-flex flex-row align-items-center justify-content-center">
    <img src="../../assets/img/popups/what-to-do-popup.webp" class="central-image" />
  </div>
</app-lateral-panel>

<app-lateral-panel id="smart-lateral" class="subtitle-info-lateral primary"  [extraClasses]="'grey house-footer-image m-w-768'">
  <h3 class="primary m-b-question m-t-question">
    {{'b2c.IDS_WTD_SMART_POPUP_TITLE' | translate}}
  </h3>
  <p class="primary m-b-36">
    {{'b2c.IDS_WTD_SMART_POPUP_DESCRIPTION' | translate}}
  </p>
  <div class="d-flex flex-row align-items-center justify-content-center">
    <img src="../../assets/img/popups/what-to-do-popup.webp" class="central-image" />
  </div>
</app-lateral-panel>

<app-lateral-panel id="quotation-lateral" class="subtitle-info-lateral primary"  [extraClasses]="'grey house-footer-image m-w-768'">
  <h3 class="primary m-b-question m-t-question">
    {{'b2c.IDS_WTD_QUOTATION_POPUP_TITLE' | translate}}
  </h3>
  <p class="primary m-b-36">
    {{'b2c.IDS_WTD_QUOTATION_POPUP_DESCRIPTION' | translate}}
  </p>
  <div class="d-flex flex-row align-items-center justify-content-center">
    <img src="../../assets/img/popups/what-to-do-popup.webp" class="central-image" />
  </div>
</app-lateral-panel>
-->
